import React from 'react';
import { SIDEBAR_MENU_BUTTON_SIZE } from '@/const';
import dataMindLogo from '@/assets/images/data-mind-logo.svg';
import razorLabsLogo from '@/assets/images/razor-labs-logo.svg';
import appIcon from '@/assets/images/appicon@3x.png';

export function AppLogo({ size, minW }: { size: string; minW?: string }) {
  return (
    <div style={{ minWidth: minW }}>
      <img src={dataMindLogo} alt="DataMind" width={size} />
    </div>
  );
}

export const RazorLabsLogo = ({ width = '353px' }: { width?: string }) => {
  return (
    <div>
      <img src={razorLabsLogo} alt="DataMind" width={width} />
    </div>
  );
};
